import React from 'react';
import { Upload, message, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

class UploadForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFileList: null,
      selectedFile: null,
      loading: false,
    };
  }

  /**
   * A validation check to help the user not uploading wrong files.
   * @param file
   * @returns {boolean}
   */
  handleBeforeUpload(file) {
    switch (file.name.split('.').pop()) {
      case 'csv':
        return true;

      default:
        message.error('Det tillades kun at hente .csv filer.');
        return false;
    }
  }

  /**
   * Uploads a csv file and creates a search string.
   * @param info
   */
  handleUpload = (info) => {
    const nextState = {};
    switch (info.file.status) {
      case 'uploading':
        this.setState({ loading: true });
        nextState.selectedFileList = [info.file];
        break;
      case 'done':
        this.setState({ loading: false });
        nextState.selectedFile = info.file;
        nextState.selectedFileList = [info.file];
        this.handleChosenFile(info.file.originFileObj);
        message.success(info.file.name + ' blev indlæst.');
        break;

      default:
        // error or removed
        this.setState({ loading: false });
        nextState.selectedFile = null;
        nextState.selectedFileList = [];
    }
    this.setState(() => nextState);
  };

  /**
   * A delay to verify upload was successfull.
   * @param file that is uploaded.
   * @param onSuccess the event triggered.
   */
  handleCustomRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };

  /**
   * Trims the result of the read file.
   * @param evt upload component which holds the file data.
   */
  handleFileRead = (evt) => {
    const content = evt.target.result;
    this.props.handleSearch(content.trim());
  };

  /**
   * Sets configuration for filereader before reading file.
   * @param file
   */
  handleChosenFile = (file) => {
    const fileReader = new FileReader();
    fileReader.onloadend = this.handleFileRead;
    fileReader.readAsText(file, 'ISO-8859-1');
  };

  render() {
    const acceptFileTypes =
      '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';

    return (
      <Upload
        accept={acceptFileTypes}
        fileList={this.state.selectedFileList}
        onChange={this.handleUpload}
        beforeUpload={this.handleBeforeUpload}
        customRequest={this.handleCustomRequest}
        multiple={true}
        showUploadList={false}
      >
        <Button>
          <UploadOutlined /> Importer csv
        </Button>
      </Upload>
    );
  }
}

export default UploadForm;
